'use client';

import type { CollapsibleTriggerProps } from '@radix-ui/react-collapsible';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { ChevronDown } from 'lucide-react';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleTriggerIcon = ({ title }: { title: string }) => {
  return (
    <CollapsibleTrigger className='group flex w-full items-center justify-between border-b py-2 text-left text-sm uppercase text-muted-foreground data-[state=open]:mb-4'>
      {title}
      <ChevronDown className='group-data-[state=open]:rotate-180'></ChevronDown>
    </CollapsibleTrigger>
  );
};
const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  CollapsibleTriggerIcon,
  type CollapsibleTriggerProps,
};
